import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function CTABanner() {
  return (
    <section data-testid="cta-banner" className="grain relative overflow-hidden bg-ocean py-24">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: "url('https://customer-assets-gfyr7b9c.emergentagent.net/job_somnath-coastal-stay/artifacts/2yy0xsdi_IMG_0893.jpeg')" }}
      />
      <div className="relative mx-auto max-w-4xl px-5 text-center">
        <Reveal>
          <p className="overline-label !text-gold">The Sea is Calling</p>
          <h2 className="mt-4 font-display text-4xl tracking-tight text-sand sm:text-5xl">
            Your Somnath journey begins at the water's edge
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-sand/70">
            Reserve directly through our official website for a simple, transparent booking experience and the best available rate.
          </p>
          <Link to="/book" data-testid="cta-book-btn" className="btn-primary mt-9">
            Book Your Stay
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
